import { OrganizationAgent } from '@igs-web/common-models/models/organization-agent-model'
import { RequestConfig, apiClient } from '@igs-web/common-utilities/api/api-client'

class OrganizationAgentApiClient {
    public readonly getOrganizationAgents = async (partyIds: ReadonlyArray<number>, config?: RequestConfig) =>
        await apiClient.postAuthed<ReadonlyArray<OrganizationAgent>>(`${apiClient.apiBaseUrl}/OrganizationAgents`, partyIds, config)
}

export const organizationAgentApiClient = new OrganizationAgentApiClient()
